<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">
      {{ alert_success_message }}
    </b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">
      {{ alert_error_message }}
    </b-alert>

    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-form-group id="grp_txt_order_number" label="Order Number:" label-for="txt_order_number" label-size="sm">
          <b-form-input id="txt_order_number" type="text" required placeholder
            v-model="change_request_obj.order_number"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_attention" label="Customer Name:" label-for="txt_attention" label-size="sm">
          <b-form-input id="txt_attention" type="text" required placeholder
            v-model="change_request_obj.attention"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_phone" label="Phone:" label-for="txt_phone" label-size="sm">
          <b-form-input id="txt_phone" type="text" required placeholder
            v-model="change_request_obj.phone"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_address" label="Address:" label-for="txt_address" label-size="sm">
          <b-form-input id="txt_address" type="text" required placeholder
            v-model="change_request_obj.address"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_schedule_date" label="Scheduled Delivery Date:" label-for="txt_schedule_date"
          label-size="sm">
          <b-form-input id="txt_schedule_date" type="date" required placeholder
            v-model="change_request_obj.schedule_date"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_status" label="Status:" label-for="txt_status" label-size="sm">
          <b-form-select size="sm" v-model="change_request_obj.status" :options="status_options" />
        </b-form-group>

        <b-form-group id="grp_txt_other_reason" label="Reason:" label-for="txt_other_reason" label-size="sm"
          v-if="change_request_obj.status == 'Unsuccessful_OtherX'">
          <b-form-input id="txt_other_reason" type="text" required placeholder
            v-model="change_request_obj.other_reason"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_reschedule_date" label="Reschedule Date:" label-for="txt_reschedule_date"
          label-size="sm" v-if="change_request_obj.status == 'Rescheduled'">
          <b-form-input id="txt_reschedule_date" type="date" required placeholder
            v-model="change_request_obj.reschedule_date"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_remark" label="Remark:" label-for="txt_remark" label-size="sm">
          <b-form-input id="txt_remark" type="text" required placeholder
            v-model="change_request_obj.remark"></b-form-input>
        </b-form-group>

        <b-form-group id="grp_txt_payment_status" label="Payment Status:" label-for="txt_payment_status"
          label-size="sm">
          <b-form-select id="txt_payment_status" size="sm" v-model="change_request_obj.payment_status"
            :options="payment_status_options" />
        </b-form-group>

        <template v-if="showProductSections">

          <div class="product-request-section section-replace">
            <div class="product-request-header">
              <div class="product-request-title">Replace Product(s)</div>
              <div class="product-request-desc">Replace one SKU with another SKU</div>
            </div>

            <div class="product-request-body">
              <div v-for="(item, index) in change_request_obj.replace_products" :key="'replace-product-' + index"
                class="product-row-box">
                <b-row>
                  <b-col cols="12" md="5">
                    <label class="small mb-1">From Channel SKU</label>
                    <b-form-input size="sm" type="text" v-model.trim="item.from_sku"
                      placeholder="Enter source SKU"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="5">
                    <label class="small mb-1">To Channel SKU</label>
                    <b-form-input size="sm" type="text" v-model.trim="item.to_sku"
                      placeholder="Enter target SKU"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="2" class="d-flex align-items-end mt-2 mt-md-0">
                    <b-button size="sm" block variant="outline-danger" @click="removeReplaceProductRow(index)"
                      :disabled="change_request_obj.replace_products.length === 1">
                      Remove
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-button size="sm" variant="outline-primary" class="mt-2" @click="addReplaceProductRow()">
                + Add Replace Product
              </b-button>
            </div>
          </div>

          <div class="product-request-section section-add">
            <div class="product-request-header">
              <div class="product-request-title">Add Product(s)</div>
              <div class="product-request-desc">Request to add extra item(s) into the order</div>
            </div>

            <div class="product-request-body">
              <div v-for="(item, index) in change_request_obj.add_products" :key="'add-product-' + index"
                class="product-row-box">
                <b-row>
                  <b-col cols="12" md="5">
                    <label class="small mb-1">Channel SKU</label>
                    <b-form-input size="sm" type="text" v-model.trim="item.sku" placeholder="Enter SKU"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="5">
                    <label class="small mb-1">Qty</label>
                    <b-form-input size="sm" type="number" min="1" v-model.number="item.qty"
                      placeholder="Enter quantity"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="2" class="d-flex align-items-end mt-2 mt-md-0">
                    <b-button size="sm" block variant="outline-danger" @click="removeAddProductRow(index)"
                      :disabled="change_request_obj.add_products.length === 1">
                      Remove
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-button size="sm" variant="outline-primary" class="mt-2" @click="addAddProductRow()">
                + Add Product
              </b-button>
            </div>
          </div>

          <div class="product-request-section section-remove">
            <div class="product-request-header">
              <div class="product-request-title">Remove Product(s)</div>
              <div class="product-request-desc">Request to remove item(s) from the order</div>
            </div>

            <div class="product-request-body">
              <div v-for="(item, index) in change_request_obj.remove_products" :key="'remove-product-' + index"
                class="product-row-box">
                <b-row>
                  <b-col cols="12" md="10">
                    <label class="small mb-1">Channel SKU</label>
                    <b-form-input size="sm" type="text" v-model.trim="item.sku" placeholder="Enter SKU"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="2" class="d-flex align-items-end mt-2 mt-md-0">
                    <b-button size="sm" block variant="outline-danger" @click="removeRemoveProductRow(index)"
                      :disabled="change_request_obj.remove_products.length === 1">
                      Remove
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-button size="sm" variant="outline-primary" class="mt-2" @click="addRemoveProductRow()">
                + Remove Product
              </b-button>
            </div>
          </div>

          <div class="product-request-section section-adjust">
            <div class="product-request-header">
              <div class="product-request-title">Adjust Product(s)</div>
              <div class="product-request-desc">Adjust the quantity of an existing product</div>
            </div>

            <div class="product-request-body">
              <div v-for="(item, index) in change_request_obj.adjust_products" :key="'adjust-product-' + index"
                class="product-row-box">
                <b-row>
                  <b-col cols="12" md="5">
                    <label class="small mb-1">Channel SKU</label>
                    <b-form-input size="sm" type="text" v-model.trim="item.sku" placeholder="Enter SKU"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="5">
                    <label class="small mb-1">New Qty</label>
                    <b-form-input size="sm" type="number" min="1" v-model.number="item.qty"
                      placeholder="Enter new quantity"></b-form-input>
                  </b-col>

                  <b-col cols="12" md="2" class="d-flex align-items-end mt-2 mt-md-0">
                    <b-button size="sm" block variant="outline-danger" @click="removeAdjustProductRow(index)"
                      :disabled="change_request_obj.adjust_products.length === 1">
                      Remove
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-button size="sm" variant="outline-primary" class="mt-2" @click="addAdjustProductRow()">
                + Add Adjust Product
              </b-button>
            </div>
          </div>
        </template>
        <b-button class="float-right" type="submit" variant="primary" @click="createChangeRequest()">
          Submit
        </b-button>
      </b-card>

      <b-modal ref="modal_confirmAttention" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Order#: {{ confirm_attention_obj.order_number }}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Confirm Attention:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-input id="input-small" size="sm" type="text" placeholder="..."
                v-model="confirm_attention_obj.attention"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmAttention">
            Cancel
          </b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="confirmAttention()">
            Confirm
          </b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

export default {
  name: "TrackingEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      confirm_attention_obj: {},
      payment_status_options: [
        { value: null, text: "---" },
        { value: "Pending", text: "Pending" },
        { value: "Partial Paid", text: "Partial Paid" },
        { value: "Fully Paid", text: "Fully Paid" }
      ],
      status_options: [
        {
          value: null,
          text: "---"
        },
        {
          value: "Cancelled",
          text: "Cancelled"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "null",
          text: "Others"
        },
        {
          value: "UnHold",
          text: "UnHold"
        }
      ],
      breadcrumb_items: [
        {
          text: "Delivery Case",
          to: { name: "change_requests" }
        },
        {
          text: "Create",
          active: true
        }
      ],
      change_request_obj_org: {
        order_number: "",
        attention: "",
        phone: "",
        address: "",
        status: "",
        other_reason: "",
        reschedule_date: "",
        remark: "",
        schedule_date: "",
        payment_status: "",
        replace_products: [],
        add_products: [],
        remove_products: [],
        adjust_products: []
      },
      change_request_obj: {
        order_number: "",
        attention: "",
        phone: "",
        address: "",
        status: "",
        other_reason: "",
        reschedule_date: "",
        remark: "",
        schedule_date: "",
        payment_status: "",
        replace_products: [
          {
            from_sku: "",
            to_sku: ""
          }
        ],
        add_products: [
          {
            sku: "",
            qty: null
          }
        ],
        remove_products: [
          {
            sku: ""
          }
        ],
        adjust_products: [
          {
            sku: "",
            qty: null
          }
        ]
      },
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      showAlert_error: false,
      alert_error_message: "",
      user_id: false
    };
  },
  async created() {
    if (this.$route.params.tracking_id) {
      await this.getTracking();
    }
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
    this.loader.hide();
  },
  computed: {
    showProductSections() {
      return String(this.$store.state.user_obj.client_id) !== "11";
    }
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    emptyReplaceProductRow() {
      return {
        from_sku: "",
        to_sku: ""
      };
    },

    emptyAddProductRow() {
      return {
        sku: "",
        qty: null
      };
    },

    emptyRemoveProductRow() {
      return {
        sku: ""
      };
    },

    emptyAdjustProductRow() {
      return {
        sku: "",
        qty: null
      };
    },

    ensureReplaceProductRows() {
      if (
        !this.change_request_obj.replace_products ||
        !Array.isArray(this.change_request_obj.replace_products) ||
        this.change_request_obj.replace_products.length === 0
      ) {
        this.$set(this.change_request_obj, "replace_products", [
          this.emptyReplaceProductRow()
        ]);
      }
    },

    ensureAddProductRows() {
      if (
        !this.change_request_obj.add_products ||
        !Array.isArray(this.change_request_obj.add_products) ||
        this.change_request_obj.add_products.length === 0
      ) {
        this.$set(this.change_request_obj, "add_products", [
          this.emptyAddProductRow()
        ]);
      }
    },

    ensureRemoveProductRows() {
      if (
        !this.change_request_obj.remove_products ||
        !Array.isArray(this.change_request_obj.remove_products) ||
        this.change_request_obj.remove_products.length === 0
      ) {
        this.$set(this.change_request_obj, "remove_products", [
          this.emptyRemoveProductRow()
        ]);
      }
    },

    ensureAdjustProductRows() {
      if (
        !this.change_request_obj.adjust_products ||
        !Array.isArray(this.change_request_obj.adjust_products) ||
        this.change_request_obj.adjust_products.length === 0
      ) {
        this.$set(this.change_request_obj, "adjust_products", [
          this.emptyAdjustProductRow()
        ]);
      }
    },

    addReplaceProductRow() {
      this.ensureReplaceProductRows();
      this.change_request_obj.replace_products.push(this.emptyReplaceProductRow());
    },

    removeReplaceProductRow(index) {
      this.ensureReplaceProductRows();

      if (this.change_request_obj.replace_products.length === 1) {
        this.change_request_obj.replace_products = [this.emptyReplaceProductRow()];
        return;
      }

      this.change_request_obj.replace_products.splice(index, 1);
    },

    addAddProductRow() {
      this.ensureAddProductRows();
      this.change_request_obj.add_products.push(this.emptyAddProductRow());
    },

    removeAddProductRow(index) {
      this.ensureAddProductRows();

      if (this.change_request_obj.add_products.length === 1) {
        this.change_request_obj.add_products = [this.emptyAddProductRow()];
        return;
      }

      this.change_request_obj.add_products.splice(index, 1);
    },

    addRemoveProductRow() {
      this.ensureRemoveProductRows();
      this.change_request_obj.remove_products.push(this.emptyRemoveProductRow());
    },

    removeRemoveProductRow(index) {
      this.ensureRemoveProductRows();

      if (this.change_request_obj.remove_products.length === 1) {
        this.change_request_obj.remove_products = [this.emptyRemoveProductRow()];
        return;
      }

      this.change_request_obj.remove_products.splice(index, 1);
    },

    addAdjustProductRow() {
      this.ensureAdjustProductRows();
      this.change_request_obj.adjust_products.push(this.emptyAdjustProductRow());
    },

    removeAdjustProductRow(index) {
      this.ensureAdjustProductRows();

      if (this.change_request_obj.adjust_products.length === 1) {
        this.change_request_obj.adjust_products = [this.emptyAdjustProductRow()];
        return;
      }

      this.change_request_obj.adjust_products.splice(index, 1);
    },

    async getTracking() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          tracking_id: this.$route.params.tracking_id
        }
      });

      if (response.data.trackings[0].attention_driver) {
        response.data.trackings[0].attention =
          response.data.trackings[0].attention_driver;
      }

      if (response.data.trackings[0].phone_driver) {
        response.data.trackings[0].phone =
          response.data.trackings[0].phone_driver;
      }

      if (response.data.trackings[0].address_driver) {
        response.data.trackings[0].address =
          response.data.trackings[0].address_driver;
      }

      this.change_request_obj_org = JSON.parse(
        JSON.stringify(response.data.trackings[0])
      );

      this.change_request_obj = JSON.parse(
        JSON.stringify(response.data.trackings[0])
      );

      if (
        !this.change_request_obj.replace_products ||
        !Array.isArray(this.change_request_obj.replace_products)
      ) {
        this.$set(this.change_request_obj, "replace_products", [
          this.emptyReplaceProductRow()
        ]);
      }

      if (
        !this.change_request_obj.add_products ||
        !Array.isArray(this.change_request_obj.add_products)
      ) {
        this.$set(this.change_request_obj, "add_products", [
          this.emptyAddProductRow()
        ]);
      }

      if (
        !this.change_request_obj.remove_products ||
        !Array.isArray(this.change_request_obj.remove_products)
      ) {
        this.$set(this.change_request_obj, "remove_products", [
          this.emptyRemoveProductRow()
        ]);
      }

      if (
        !this.change_request_obj.adjust_products ||
        !Array.isArray(this.change_request_obj.adjust_products)
      ) {
        this.$set(this.change_request_obj, "adjust_products", [
          this.emptyAdjustProductRow()
        ]);
      }

      if (
        !this.change_request_obj_org.replace_products ||
        !Array.isArray(this.change_request_obj_org.replace_products)
      ) {
        this.$set(this.change_request_obj_org, "replace_products", []);
      }

      if (
        !this.change_request_obj_org.add_products ||
        !Array.isArray(this.change_request_obj_org.add_products)
      ) {
        this.$set(this.change_request_obj_org, "add_products", []);
      }

      if (
        !this.change_request_obj_org.remove_products ||
        !Array.isArray(this.change_request_obj_org.remove_products)
      ) {
        this.$set(this.change_request_obj_org, "remove_products", []);
      }

      if (
        !this.change_request_obj_org.adjust_products ||
        !Array.isArray(this.change_request_obj_org.adjust_products)
      ) {
        this.$set(this.change_request_obj_org, "adjust_products", []);
      }

      this.items.push(response.data.trackings[0]);
      this.history_items = response.data.tracking_status_historys;
      this.loader.hide();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    async confirmAttention() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_confirm_attention.php",
        data: {
          order_number: this.confirm_attention_obj.order_number,
          attention: this.confirm_attention_obj.attention,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      if (response.data.is_valid_request == "1") {
        await this.doCreateChangeRequest();
      } else {
        this.alert_error_message = `Attention doesn't match with Order#`;
        this.showAlert_error = true;
        window.scrollTo(0, 0);
        this.hideModal_confirmAttention();
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 5000);
        return;
      }
    },

    showModal_confirmAttention(item) {
      this.confirm_attention_obj = {
        order_number: item.order_number,
        attention: ""
      };
      this.$refs.modal_confirmAttention.show();
    },

    hideModal_confirmAttention() {
      this.$refs.modal_confirmAttention.hide();
    },

    submitForm() {
      this.updateTracking(this.tracking);
    },

    async doCreateChangeRequest() {
      let fields = [
        {
          name: "attention",
          from_val: this.change_request_obj_org.attention,
          to_val: this.change_request_obj.attention,
          remark: this.change_request_obj.remark
        },
        {
          name: "phone",
          from_val: this.change_request_obj_org.phone,
          to_val: this.change_request_obj.phone,
          remark: this.change_request_obj.remark
        },
        {
          name: "address",
          from_val: this.change_request_obj_org.address,
          to_val: this.change_request_obj.address,
          remark: this.change_request_obj.remark
        },
        {
          name: "status",
          from_val: this.change_request_obj_org.status,
          to_val: this.change_request_obj.status,
          other_reason: this.change_request_obj.other_reason,
          reschedule_date: this.change_request_obj.reschedule_date,
          remark: this.change_request_obj.remark,
          attention: this.change_request_obj_org.attention
        },
        {
          name: "schedule_date",
          from_val: this.change_request_obj_org.schedule_date,
          to_val: this.change_request_obj.schedule_date,
          remark: this.change_request_obj.remark
        },
        {
          name: "payment_status",
          from_val: this.change_request_obj_org.payment_status,
          to_val: this.change_request_obj.payment_status,
          remark: this.change_request_obj.remark
        }
      ];

      const replaceFields = (this.change_request_obj.replace_products || [])
        .filter(row => {
          const fromSku = (row.from_sku || "").trim();
          const toSku = (row.to_sku || "").trim();
          return fromSku !== "" || toSku !== "";
        })
        .map((row, index) => {
          return {
            name: "replace_product",
            from_val: (row.from_sku || "").trim(),
            to_val: (row.to_sku || "").trim(),
            remark: this.change_request_obj.remark,
            row_no: index + 1
          };
        });

      const addFields = (this.change_request_obj.add_products || [])
        .filter(row => {
          const sku = (row.sku || "").trim();
          const qty = Number(row.qty || 0);
          return sku !== "" || qty > 0;
        })
        .map((row, index) => {
          return {
            name: "add_product",
            from_val: "",
            to_val: (row.sku || "").trim(),
            qty: Number(row.qty || 0),
            remark: this.change_request_obj.remark,
            row_no: index + 1
          };
        });

      const removeFields = (this.change_request_obj.remove_products || [])
        .filter(row => {
          const sku = (row.sku || "").trim();
          return sku !== "";
        })
        .map((row, index) => {
          return {
            name: "remove_product",
            from_val: (row.sku || "").trim(),
            to_val: "",
            remark: this.change_request_obj.remark,
            row_no: index + 1
          };
        });

      const adjustFields = (this.change_request_obj.adjust_products || [])
        .filter(row => {
          const sku = (row.sku || "").trim();
          const qty = Number(row.qty || 0);
          return sku !== "" || qty > 0;
        })
        .map((row, index) => {
          return {
            name: "adjust_product",
            from_val: (row.sku || "").trim(),
            to_val: "",
            qty: Number(row.qty || 0),
            remark: this.change_request_obj.remark,
            row_no: index + 1
          };
        });

      fields = fields.concat(replaceFields, addFields, removeFields, adjustFields);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_add.php",
        data: {
          tracking_id: this.$route.params.tracking_id,
          order_number: this.change_request_obj.order_number,
          fields: fields,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Change Request Created Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.$router.go(-1);
      } else {
        alert(response.data.error_msg);
      }
    },

    async createChangeRequest() {
      if (this.change_request_obj.order_number.trim() == "") {
        this.alert_error_message = `Order number is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
        return;
      }

      const replaceProducts = this.change_request_obj.replace_products || [];

      for (let i = 0; i < replaceProducts.length; i++) {
        const fromSku = (replaceProducts[i].from_sku || "").trim();
        const toSku = (replaceProducts[i].to_sku || "").trim();

        if ((fromSku !== "" && toSku === "") || (fromSku === "" && toSku !== "")) {
          this.alert_error_message =
            `Replace Product row ${i + 1}: both From SKU and To SKU are required`;
          this.showAlert_error = true;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.showAlert_error = false;
            this.alert_error_message = "";
          }, 4000);
          return;
        }
      }

      const addProducts = this.change_request_obj.add_products || [];

      for (let i = 0; i < addProducts.length; i++) {
        const sku = (addProducts[i].sku || "").trim();
        const qty = Number(addProducts[i].qty || 0);

        if ((sku !== "" && qty <= 0) || (sku === "" && qty > 0)) {
          this.alert_error_message =
            `Add Product row ${i + 1}: both SKU and Qty are required`;
          this.showAlert_error = true;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.showAlert_error = false;
            this.alert_error_message = "";
          }, 4000);
          return;
        }
      }

      const adjustProducts = this.change_request_obj.adjust_products || [];

      for (let i = 0; i < adjustProducts.length; i++) {
        const sku = (adjustProducts[i].sku || "").trim();
        const qty = Number(adjustProducts[i].qty || 0);

        if ((sku !== "" && qty <= 0) || (sku === "" && qty > 0)) {
          this.alert_error_message =
            `Adjust Product row ${i + 1}: both SKU and New Qty are required`;
          this.showAlert_error = true;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.showAlert_error = false;
            this.alert_error_message = "";
          }, 4000);
          return;
        }
      }

      await this.doCreateChangeRequest();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.product-request-section {
  margin-top: 20px;
  margin-bottom: 24px;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.product-request-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.product-request-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
}

.product-request-desc {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

.product-request-body {
  padding: 16px;
}

.product-row-box {
  border: 1px dashed #ced4da;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  background: #fcfcfc;
}

.section-replace {
  border-left: 4px solid #6c757d;
}

.section-add {
  border-left: 4px solid #28a745;
}

.section-remove {
  border-left: 4px solid #dc3545;
}

.section-adjust {
  border-left: 4px solid #fd7e14;
}
</style>


// WEBPACK FOOTER //
// src/components/ChangeRequestAdd.vue